/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

import * as child_process from 'child_process';
import * as util from 'util';

export const execAsync = util.promisify(child_process.exec);
